import React from 'react';
import { FaCog, FaEdit } from 'react-icons/fa';

const MarkingRulesModal = ({
  rules,
  selectedRule,
  handleRuleChange,
  showCustomSection,
  toggleCustomSection,
  customMarkingRules,
  handleCustomMarkingChange,

  // 🔥 NEW PROPS
  readingTime,
  setReadingTime
}) => {
  return (
    <div className="p-2 rounded-2xl border bg-white shadow-sm space-y-3">
      
      <h3 className="font-semibold flex items-center gap-3 text-[#861426]">
        Marking Rules
      </h3>

      {/* ================= DICTATION READING TIME ================= */}
      <div>
        <label className="block mb-1 font-semibold text-[#861426]">
          Dictation Reading Time
        </label>

        <select
          value={readingTime}
          onChange={(e) => setReadingTime(e.target.value)}
          className="w-full p-2 rounded-xl border focus:ring-2 focus:ring-[#1d3a80]"
        >
          <option value="30">30 Seconds</option>
          <option value="60">1 Minute</option>
          <option value="120">2 Minutes</option>
          <option value="180">3 Minutes</option>
        </select>

        <p className="text-xs text-gray-500 mt-1">
          Time given to read dictation before typing starts
        </p>
      </div>

      {/* ================= PREDEFINED RULES ================= */}
      <div>
        <label className="block mb-1 font-semibold text-[#861426]">
          Select Marking Rule
        </label>

        <select
          value={selectedRule}
          onChange={handleRuleChange}
          className="w-full p-2 rounded-xl border"
        >
          {rules.map(rule => (
            <option key={rule._id} value={rule._id}>
              {rule.title}
            </option>
          ))}
          <option value="custom">Custom Marking Rules</option>
        </select>
      </div>

      {/* ================= CUSTOM TOGGLE ================= */}
      <button
        onClick={toggleCustomSection}
        className="px-3 py-2 rounded-lg bg-[#1d3a80] text-white text-sm font-semibold"
      >
        {showCustomSection ? 'Cancel Custom Rules' : 'Create Custom Rules'}
      </button>

      {/* ================= CUSTOM RULES ================= */}
      {showCustomSection && (
        <div className="space-y-3">
          {customMarkingRules.map(rule => (
            <div key={rule.mistakeId} className="border rounded-xl p-4">
              <p className="font-semibold">{rule.mistakeName}</p>

              <div className="flex gap-6 mt-2">
                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    checked={rule.mistakeType === 'full'}
                    onChange={() =>
                      handleCustomMarkingChange(rule.mistakeId, 'full')
                    }
                  />
                  Full (-1)
                </label>

                <label className="flex items-center gap-2">
                  <input
                    type="radio"
                    checked={rule.mistakeType === 'half'}
                    onChange={() =>
                      handleCustomMarkingChange(rule.mistakeId, 'half')
                    }
                  />
                  Half (-0.5)
                </label>
              </div>
            </div>
          ))}
        </div>
      )}

    </div>
  );
};

export default MarkingRulesModal;
